import React, { useEffect, useRef, useState } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import { v4 as uuid } from "uuid";
import jwt_decode from "jwt-decode";
import { GoogleOAuthProvider } from "@react-oauth/google";
import api from "./components/api";
import Brands from "./pages/Brands";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Store from "./pages/Store";
import NotFound from "./pages/NotFound";
import Cms from "./pages/Cms";
import "./css/App.css";
import "./css/Forms.css";
import "./css/Header.css";
import "./css/Menu.css";
import "./css/Store.css";
import "./css/Cart.css";
import "./css/PopUp.css";
import "./css/ProductSheet.css";
import "./css/Login.css";
import "./css/Userboard.css";
import "./css/Checkout.css";
import "./css/Buttons.css";
import "./css/Shop.css";
import "./css/PromoLevels.css";
import "./css/Booking.css";
import "./css/Home.css";
import "./css/CmsMenu.css";
import "./css/Footer.css";
import "./css/cms-popups.css";
import "./css/Maintenance.css";
import Shop from "./pages/Shop";
import Login from "./pages/Login";
import LoginEmailLogin from "./pages/LoginEmailLogin";
import LoginCheckEmail from "./pages/LoginCheckEmail";
import Userboard from "./pages/Userboard";
import BillingAddress from "./pages/BillingAddress";
import Orders from "./pages/Orders";
import { getCookie, setCookie } from "./components/functions";
import Bookings from "./pages/Bookings";
import Checkout from "./pages/Checkout";
import OrderConfirmed from "./pages/OrderConfirmed";
import PagePopup from "./pages/PagePopup";
import PointsTransactions from "./pages/PointsTransactions";
import CreditTransactions from "./pages/CreditTransactions";
import SignUp from "./pages/SignUp";
import CheckCode from "./pages/CheckCode";
import CheckPasswordCode from "./pages/CheckPasswordCode";
import NewPassword from "./pages/NewPassword";
import Booking from "./pages/Booking";
import BookingConfirmed from "./pages/BookingConfirmed";
import Promo from "./pages/Promo";
import ReactPixel from "react-facebook-pixel";
import Label from "./components/Label";
import NewsList from "./pages/NewsList";
import News from "./pages/News";
import Shops from "./pages/Shops";
import BookingSheet from "./pages/BookingSheet";
import CmsPopups from "./components/CmsPopups";
import RestorePassword from "./pages/RestorePassword";
import moment from "moment";
import ReactGA from "react-ga4";
import LoginCheckMobile from "./pages/LoginCheckMobile";
import SignUpMobile from "./pages/SignUpMobile";
import CheckCodeMobile from "./pages/CheckCodeMobile";
import LoginMobileLogin from "./pages/LoginMobileLogin";
import CheckPasswordCodeSms from "./pages/CheckPasswordCodeSms";
import TagManager from "react-gtm-module";
import RelatedProductsPopup from "./pages/RelatedProductsPopup";
import ProductSheet from "./pages/ProductSheet";
import StorePopUp from "./components/StorePopUp";
import Confirm from "./components/confirm";
import Maintenance from "./components/Maintenance";
import LoadIcon from "./components/icons/LoadIcon";
import LoginCheckHotel from "./pages/LoginCheckHotel";
import CheckCodeHotel from "./pages/CheckCodeHotel";
import PromoPopup from "./components/PromoBanner/PromoPopup";
import { useAppStore } from "./useAppStore";
import { useDeliveryDateChangeAlert } from "./hooks/useDeliveryDateChangeAlert";
import { adaptMenuFlat } from "./menu/MenuFlatAdapter";

export const AppContext = React.createContext();

const savedBrandCookie = getCookie("website-brand");
let savedBrand = false;
if (savedBrandCookie == "main") savedBrand = "main";
else if (savedBrandCookie != "") savedBrand = JSON.parse(savedBrandCookie);
console.log("saved brand", savedBrand);
const HAS_SAVED_BRAND_AT_INIT = savedBrandCookie != "";
const SKIP_STORE_BRAND_POPUP_UNTIL_KEY = "skip-store-brand-popup-until";

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const initialHotelFromQuery = queryParams.get("hotel_id");
  const initialStoredHotel = localStorage.getItem("website-hotel-id");
  const hasInitialHotelContext = !!(initialHotelFromQuery || initialStoredHotel);
  const isInitialBookingLanding =
    window.location.pathname == "/booking" || window.location.pathname == "/booking/";
  const shouldResetHotelOnInitialBookingLanding =
    isInitialBookingLanding && !initialHotelFromQuery && !!initialStoredHotel;
  const { promoPopupVisible, setPromoPopupVisible } = useAppStore();
  const [lock, setLock] = useState(true);
  const [lang, setLang] = useState(
    localStorage.getItem("website-lang") ? localStorage.getItem("website-lang") : "it",
  );
  const [tempId, setTempId] = useState(
    localStorage.getItem("website-temp-id") ? localStorage.getItem("website-temp-id") : false,
  );
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(false);
  const [labels, setLabels] = useState(false);
  const [pages, setPages] = useState([]);
  const [shops, setShops] = useState([]);
  const [brand, setBrand] = useState(hasInitialHotelContext ? false : savedBrand);
  const [menu, setMenu] = useState([]);
  const [courses, setCourses] = useState([]);
  const [shop, setShop] = useState(false);
  const [listId, setListId] = useState(false);
  const [category, setCategory] = useState(false);
  const [user, setUser] = useState(false);
  const [cart, setCart] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [lastOrderId, setLastOrderId] = useState(false);
  const [lastOrderNumber, setLastOrderNumber] = useState(false);
  const [lastOrderTotal, setLastOrderTotal] = useState(0);
  const [pagePopup, setPagePopup] = useState(false);
  const [tempUser, setTempUser] = useState({ id: "", area_code: "+39", mobile: "", email: "" });
  const [loginPopup, setLoginPopup] = useState(false);
  const [discounts, setDiscounts] = useState(false);
  const [news, setNews] = useState(false);
  const [menus, setMenus] = useState(false);
  const [slides, setSlides] = useState(false);
  const [popups, setPopups] = useState([]);
  const [mainSettings, setMainSettings] = useState(false);
  const [hotel, setHotel] = useState(
    initialHotelFromQuery || (shouldResetHotelOnInitialBookingLanding ? false : initialStoredHotel),
  );
  const [hotelInfo, setHotelInfo] = useState(false);
  const [hotelBrandResolved, setHotelBrandResolved] = useState(
    !(initialHotelFromQuery || (shouldResetHotelOnInitialBookingLanding ? false : initialStoredHotel)),
  );
  const [hotelBrandSelectionRequired, setHotelBrandSelectionRequired] = useState(false);
  const [hotelAvailableChilds, setHotelAvailableChilds] = useState([]);
  const [hotelAvailableBrands, setHotelAvailableBrands] = useState([]);
  const [hotelServiceInactive, setHotelServiceInactive] = useState(false);
  const [hasOrders, setHasOrders] = useState(false);
  const [hasReservations, setHasReservations] = useState(false);
  const [hasDelivery, setHasDelivery] = useState(false);
  const [hasTakeaway, setHasTakeaway] = useState(false);
  const [loginRedirect, setLoginRedirect] = useState(false);
  const [c1, setC1] = useState(getCookie("website-cookies-a"));
  const [cookieSettingsPopupVisible, setCookieSettingsPopupVisible] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState(false);
  const [loadRelated, setLoadRelated] = useState(true);
  const [cartEnabled, setCartEnabled] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [storePopupVisible, setStorePopupVisible] = useState(false);
  const [discountsLimit, setDiscountsLimit] = useState([]);
  const [shopLocked, setShopLocked] = useState(false);
  const [stock, setStock] = useState([]);
  const [brandSelectionAtOrderInit, setBrandSelectionAtOrderInit] = useState(false);
  const [brandPopupVisible, setBrandPopupVisible] = useState(false);
  const [brandPopupRedirect, setBrandPopupRedirect] = useState("/store");
  const [brandSettingsLoadedVersion, setBrandSettingsLoadedVersion] = useState(0);
  const [forceMainBrandNavigation, setForceMainBrandNavigation] = useState(false);
  const [masterFooterMenus, setMasterFooterMenus] = useState([]);
  const [masterFooterPages, setMasterFooterPages] = useState([]);
  const [masterFooterShops, setMasterFooterShops] = useState([]);
  const [masterFooterLoaded, setMasterFooterLoaded] = useState(false);
  const [pendingMainNavigation, setPendingMainNavigation] = useState(false);
  const [initialHotelResetDone, setInitialHotelResetDone] = useState(
    !shouldResetHotelOnInitialBookingLanding,
  );
  const skipNextBrandSettingsLoadRef = useRef(false);
  const skipNextDeliveryDateAlertRef = useRef(window.location.pathname.includes("/order_confirmed"));
  const categoryTimesCartFilterRef = useRef("");

  useEffect(() => {
    console.log("Migration test 1");
    init(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (shouldResetHotelOnInitialBookingLanding) {
      const resetHotelSession = async () => {
        localStorage.removeItem("website-hotel-id");
        const storedTempId = tempId || localStorage.getItem("website-temp-id");
        if (storedTempId && !tempId) setTempId(storedTempId);
        if (storedTempId) {
          await api.post("/cart/edit/" + storedTempId + "/", { hotel_id: null });
        }
        setInitialHotelResetDone(true);
      };

      resetHotelSession();
    } else {
      setInitialHotelResetDone(true);
    }
  }, [shouldResetHotelOnInitialBookingLanding, tempId]);

  useEffect(() => {
    if (hotel) localStorage.setItem("website-hotel-id", hotel);
    else localStorage.removeItem("website-hotel-id");
  }, [hotel]);

  useEffect(() => {
    if (lang) localStorage.setItem("website-lang", lang);
  }, [lang]);

  useEffect(() => {
    document.documentElement.lang = lang || "it";
  }, [lang]);

  useEffect(() => {
    console.log("tempUser set to", tempUser);
  }, [tempUser]);

  useEffect(() => {
    if (menu) filterMenu();
  }, [menu, lang, listId, shop, discounts, cart?.delivery_date]);

  useEffect(() => {
    filterCartProductsByCategoryTimes();
  }, [cart?.delivery_date, cart?.products, menu, settings]);

  useEffect(() => {
    if (!initialHotelResetDone || !hotelBrandResolved) return;
    loadCart();
  }, [lang, user, hotel, shopLocked, settings, initialHotelResetDone, hotelBrandResolved]);

  useEffect(() => {
    if (!initialHotelResetDone) return;

    if (!hotel) {
      setHotelInfo(false);
      setHotelAvailableChilds([]);
      setHotelAvailableBrands([]);
      setHotelBrandSelectionRequired(false);
      setHotelServiceInactive(false);
      setHotelBrandResolved(true);
      return;
    }

    let cancelled = false;

    const loadHotelInfo = async () => {
      setHotelBrandResolved(false);
      setHotelBrandSelectionRequired(false);
      setHotelServiceInactive(false);

      const response = await api.get("/hotels/get/" + hotel + "/");
      if (cancelled) return;

      if (response.success === 0 || !response.data) {
        setHotelInfo(false);
        setHotelServiceInactive(true);
        setHotelBrandResolved(true);
        return;
      }

      setHotelInfo(response.data);
    };

    loadHotelInfo();

    return () => {
      cancelled = true;
    };
  }, [hotel, initialHotelResetDone]);

  useEffect(() => {
    if (!hotel) return;
    if (!mainSettings || !hotelInfo) return;

    const hotelChilds = Array.isArray(hotelInfo.childs) ? hotelInfo.childs : [];
    const rootMandantId = String(mainSettings?.mandant?.id || "");
    const configuredChilds = mainSettings?.mandant?.childs || [];
    const availableBrands = hotelChilds
      .filter((child) => Number(child.active) === 1)
      .map((child) => {
        const childId = String(child.id);
        if (childId === rootMandantId) {
          return {
            key: "main",
            value: "main",
            name: child.name || mainSettings?.global?.name,
            img: mainSettings?.global?.logo,
          };
        }

        const configuredChild = configuredChilds.find((item) => String(item.id) === childId);
        const brandValue = configuredChild || child;

        return {
          key: "child-" + child.id,
          value: brandValue,
          name: child.name,
          img: configuredChild?.img,
        };
      });

    setHotelAvailableChilds(
      availableBrands.filter((item) => item.value !== "main").map((item) => item.value),
    );
    setHotelAvailableBrands(availableBrands);

    if (hotelChilds.length === 0) {
      setHotelBrandSelectionRequired(false);
      setHotelServiceInactive(false);
      setHotelBrandResolved(true);
      return;
    }

    if (availableBrands.length === 0) {
      setHotelBrandSelectionRequired(false);
      setHotelServiceInactive(true);
      setBrandPopupVisible(false);
      setHotelBrandResolved(true);
      return;
    }

    setHotelServiceInactive(false);

    if (availableBrands.length === 1) {
      const onlyBrand = availableBrands[0].value;
      const currentBrandId = brand && brand !== "main" ? String(brand.id) : "";
      const targetBrandId = onlyBrand === "main" ? "main" : String(onlyBrand.id);
      setHotelBrandSelectionRequired(false);
      setBrandPopupVisible(false);
      if (
        (onlyBrand === "main" && brand !== "main") ||
        (onlyBrand !== "main" && currentBrandId !== targetBrandId)
      ) {
        setBrand(onlyBrand);
        return;
      }
      setHotelBrandResolved(true);
      return;
    }

    const currentBrandId = brand && brand !== "main" ? String(brand.id) : "";
    const skipUntil = parseInt(sessionStorage.getItem(SKIP_STORE_BRAND_POPUP_UNTIL_KEY) || "0", 10);
    const hasSelectedActiveBrand =
      (brand === "main" && availableBrands.some((item) => item.value === "main")) ||
      availableBrands.some((item) => item.value !== "main" && String(item.value.id) === currentBrandId);
    if (hasSelectedActiveBrand && skipUntil > Date.now()) {
      setHotelBrandSelectionRequired(false);
      setBrandPopupVisible(false);
      setHotelBrandResolved(true);
      return;
    }

    setCookie("website-brand", "", -1);
    setHotelBrandSelectionRequired(true);
    setBrandPopupRedirect(window.location.pathname + window.location.search);
    setBrandPopupVisible(true);
    if (brand !== "main") {
      setBrand("main");
      return;
    }
    setHotelBrandResolved(true);
  }, [hotel, hotelInfo, mainSettings, brand]);

  useEffect(() => {
    if (!hotelBrandSelectionRequired) return;
    if (brand === "main" || !brand) setHotelBrandResolved(true);
  }, [hotelBrandSelectionRequired, brand]);

  useEffect(() => {
    console.log("brand set to", brand);
    if (brand) {
      if (brand == "main") api.setHostname(window.location.hostname);
      else api.setHostname(brand.host);
      setLock(true);
      if (skipNextBrandSettingsLoadRef.current) {
        skipNextBrandSettingsLoadRef.current = false;
      } else {
        loadSettings();
      }
      if (brand == "main") setCookie("website-brand", brand, false);
      else setCookie("website-brand", JSON.stringify(brand), false);
    }
  }, [brand]);

  useEffect(() => {
    console.log("settings updated");
    if (settings) {
      setCartEnabled(settings.website.store_popup_auto == 1);
      loadBaseData();
      console.log("Init Tag Manager", settings.website.google_analytics);
      if (settings.website.google_analytics) {
        console.log("Init GA");
        ReactGA.initialize(settings.website.google_analytics);
      }
      if (settings.website.googletagmanager) {
        console.log("Init Tag Manager");
        const tagManagerArgs = {
          gtmId: settings.website.googletagmanager,
        };
        TagManager.initialize(tagManagerArgs);
      }
    }
  }, [settings]);

  useEffect(() => {
    if (category && settings && settings.website.google_analytics) {
      console.log("Track GA");
      ReactGA.send({
        hitType: "pageview",
        page: "/cat-" + category.id,
        title: category.name,
      });
    }
  }, [category]);

  useEffect(() => {
    let orders = false;
    let reservations = false;
    let delivery = false;
    let takeaway = false;
    if (shops) {
      for (const shop of shops) {
        if (shop.delivery == 1 || shop.takeaway == 1) orders = true;
        if (shop.active_reservations == 1) reservations = true;
        if (shop.delivery == 1) delivery = true;
        if (shop.takeaway == 1) takeaway = true;
      }
    }
    setHasOrders(orders);
    setHasReservations(reservations);
    setHasDelivery(delivery);
    setHasTakeaway(takeaway);
  }, [shops]);

  useEffect(() => {
    console.log("loginRedirect set to", loginRedirect);
  }, [loginRedirect]);

  useEffect(() => {
    if (cart) {
      // gli sconti-prodotto in modalita' "menu" cambiano con il carrello solo per quantita' e chiusura per cliente
      if (discountsMode === "legacy") loadDiscounts();
      else if (discountsMode === "menu" && discountsNeedAvailability) loadDiscountsAvailability();
      loadDiscountsLimit();
      loadProductsStock();
    }
  }, [cart]);

  useEffect(() => {
    if (!pendingMainNavigation || !forceMainBrandNavigation) return;
    if (brand == "main" && !lock) {
      const target = pendingMainNavigation;
      setPendingMainNavigation(false);
      window.history.pushState({}, "", target);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }, [pendingMainNavigation, forceMainBrandNavigation, brand, lock]);

  useEffect(() => {
    if (!forceMainBrandNavigation || !brand || brand == "main") return;
    if (masterFooterShops.length > 0) return;
    loadMasterFooterData(window.location.hostname, true);
  }, [forceMainBrandNavigation, brand, masterFooterShops]);

  useEffect(() => {
    if (!courses || courses.length === 0) return;

    const openProductFromHash = () => {
      const hash = window.location.hash; // es: #product-123
      if (!hash.startsWith("#product-")) return;

      const productId = parseInt(hash.replace("#product-", ""), 10);
      if (!productId) return;

      for (const course of courses) {
        for (const category of course.categories) {
          for (const product of category.products) {
            if (product.id === productId) {
              setSelectedProduct(product);
              return;
            }
          }
        }
      }
    };

    openProductFromHash();

    window.addEventListener("hashchange", openProductFromHash);
    return () => window.removeEventListener("hashchange", openProductFromHash);
  }, [courses]);

  const { markUserChange } = useDeliveryDateChangeAlert({
    cart,
    onAutoChange: (prev, next) => {
      if (skipNextDeliveryDateAlertRef.current) {
        skipNextDeliveryDateAlertRef.current = false;
        return;
      }

      setConfirm({
        title: "Attenzione",
        message: (
          <>
            <Label number={218} />{" "}
            {moment(cart.delivery_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm")}
          </>
        ),
      });
    },
  });

  const init = async () => {
    console.log("init");
    api.setBaseUrl();
    loadSettings(true);
    if (queryParams.get("shop_id")) {
      setShopLocked(queryParams.get("shop_id"));
      localStorage.setItem("website-shop_id", queryParams.get("shop_id"));
    }
    if (localStorage.getItem("website-shop_id")) {
      setShopLocked(localStorage.getItem("website-shop_id"));
    }
  };

  const openBrandSelectionPopup = (redirect = "/store", source = "direct-url") => {
    const canSelectHotelBrand = hotel && hotelAvailableBrands.length > 1;
    if (!brandSelectionAtOrderInit && !hotelBrandSelectionRequired && !canSelectHotelBrand) return;
    if (source == "order-button") {
      sessionStorage.setItem(SKIP_STORE_BRAND_POPUP_UNTIL_KEY, (Date.now() + 15000).toString());
    }
    setBrandPopupRedirect(redirect);
    setBrandPopupVisible(true);
  };

  const loadBaseData = async () => {
    console.log("loadBaseData");
    setLock(true);
    applyCss();
    initFbPixel();
    await loadMenus();
    await loadLabels();
    await loadPages();
    await loadSlides();
    await loadNews();
    await loadShops();
    await loadPopups();
    await restoreUser();
    setLock(false);
    setBrandSettingsLoadedVersion((v) => v + 1);
    await loadMenu();
  };

  const initFbPixel = () => {
    if (!settings.website.facebookpixel) return;
    console.log("initFbPixel", settings.website.facebookpixel);
    const options = {
      autoConfig: false,
      debug: true,
    };
    ReactPixel.init(settings.website.facebookpixel, undefined, options);

    ReactPixel.pageView();
  };

  const track = (event = false) => {
    if (settings.website.facebookpixel) ReactPixel.pageView();

    if (settings.website.googletagmanager) {
      window.dataLayer.push({
        event: "pageview",
      });
    }
  };

  const restoreUser = async () => {
    console.log("restoreUser");
    const token = queryParams.get("token") ? queryParams.get("token") : localStorage.getItem("website-user");
    console.log(token);
    if (token && token !== "null") {
      const refresh = await api.refreshToken(token);
      if (refresh.success == 0) alert(refresh.error);
      else {
        if (refresh.force_reset_password == 1) return;
        localStorage.setItem("website-user", refresh.token);
        const decoded = jwt_decode(refresh.token);
        const response = await api.getProtected("/customers/get/" + decoded.user_id + "/");
        if (response.success == 0) alert(response.error);
        else setUser(response.data);
      }
    }
  };

  const reloadUser = async () => {
    if (user) {
      const response = await api.getProtected("/customers/get/" + user.id + "/");
      if (response.success == 0) alert(response.error);
      else setUser(response.data);
    }
  };

  const loadSettings = async (is_main = false) => {
    console.log("loadSettings", is_main);
    const res = await api.post("/settings2/get/", {
      section: [
        "global",
        "website",
        "google",
        "fidelity",
        "customers",
        "orders",
        "reservations",
        "menu",
        "credit",
        "socials",
        "newsletter",
        "menu_api",
      ],
    });
    if (res.success == 0) alert(res.error);
    else {
      let initialTargetBrand = null;
      if (is_main) {
        setMainSettings(res.data);
        const selectBrandOnOrderInit = res.data.website?.brand_selection_at_order_init == 1;
        const forceMainNavigation = res.data.website?.force_main_brand_navigation == 1;
        const requestedBrandId = queryParams.get("brand_id");
        const pathname = window.location.pathname;
        const isHomePath = pathname == "/" || pathname == "/home" || pathname == "/it" || pathname == "/it/";
        setBrandSelectionAtOrderInit(selectBrandOnOrderInit);
        setForceMainBrandNavigation(forceMainNavigation);

        if (requestedBrandId) {
          let found = false;
          for (const b of res.data.mandant.childs) {
            if (b.id == requestedBrandId) {
              found = true;
              initialTargetBrand = b;
              setBrand(b);
            }
          }
          if (!found && selectBrandOnOrderInit && (isHomePath || !savedBrand)) {
            initialTargetBrand = "main";
            if (brand != "main") {
              skipNextBrandSettingsLoadRef.current = true;
              setBrand("main");
            }
          }
        } else if (selectBrandOnOrderInit && (isHomePath || !savedBrand)) {
          initialTargetBrand = "main";
          if (brand != "main") {
            skipNextBrandSettingsLoadRef.current = true;
            setBrand("main");
          }
        } else if (!selectBrandOnOrderInit && res.data.mandant.childs.length > 0) {
          let found = false;
          for (const b of res.data.mandant.childs) {
            if (b.id == requestedBrandId) {
              found = true;
              initialTargetBrand = b;
              setBrand(b);
            }
          }
          if (requestedBrandId && !found) {
            initialTargetBrand = "main";
            if (brand != "main") {
              skipNextBrandSettingsLoadRef.current = true;
              setBrand("main");
            }
          }
        }

        const effectiveInitialBrand = initialTargetBrand || brand || "main";
        if (forceMainNavigation) {
          const includeMasterShops = effectiveInitialBrand != "main";
          loadMasterFooterData(window.location.hostname, includeMasterShops);
        }
      }
      const shouldApplySettings =
        !is_main || initialTargetBrand == "main" || (!initialTargetBrand && (brand == "main" || !brand));
      if (shouldApplySettings) setSettings(res.data);

      document.title = res.data.global.name;
      var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = res.data.website.favicon;
      //document.getElementsByTagName("head")[0].appendChild(link);
    }
  };

  const loadMenus = async () => {
    console.log("loadMenus");
    const res = await api.post("/cms_menus/list/", {
      src: [{ name: "active", value: 1, compare: "equal" }],
    });
    if (res.success == 0) alert(res.error);
    else setMenus(res.rows);
  };

  const loadMasterFooterData = async (masterHost, includeShops = true) => {
    setMasterFooterLoaded(false);
    try {
      const requests = [
        api.postWithHostname(
          "/cms_menus/list/",
          { src: [{ name: "active", value: 1, compare: "equal" }] },
          masterHost,
        ),
        api.postWithHostname("/pages/list/", { orderby: "title" }, masterHost),
      ];

      if (includeShops) {
        requests.push(
          api.postWithHostname(
            "/shops/list/",
            {
              fields: [
                "id",
                "name",
                "meta_url",
                "img",
                "address",
                "number",
                "zipcode",
                "city",
                "province",
                "phone",
                "email",
                "coord",
                "times_text",
                "delivery",
                "takeaway",
                "active_reservations",
                "description",
                "additional_info",
                "gallery_id",
                "reservations_ext_url",
                "active",
              ],
              src: [{ name: "active", value: 1, compare: "equal" }],
              orderby: "position",
            },
            masterHost,
          ),
        );
      }

      const [menusRes, pagesRes, shopsRes] = await Promise.all(requests);

      setMasterFooterMenus(menusRes.success != 0 ? menusRes.rows || [] : []);
      setMasterFooterPages(pagesRes.success != 0 ? pagesRes.rows || [] : []);
      setMasterFooterShops(includeShops && shopsRes && shopsRes.success != 0 ? shopsRes.rows || [] : []);
    } finally {
      setMasterFooterLoaded(true);
    }
  };

  const navigateViaMaster = (target) => {
    if (!forceMainBrandNavigation) {
      window.history.pushState({}, "", target);
      window.dispatchEvent(new PopStateEvent("popstate"));
      return;
    }

    if (brand == "main") {
      window.history.pushState({}, "", target);
      window.dispatchEvent(new PopStateEvent("popstate"));
      return;
    }

    markUserChange();
    setPendingMainNavigation(target);
    setBrand("main");
  };

  const applyCss = () => {
    console.log("applyCss");

    document.documentElement.style.setProperty("--c1", settings.website.color5);
    document.documentElement.style.setProperty("--c1c", settings.website.color6);
    document.documentElement.style.setProperty("--c1o", settings.website.color5 + "50");
    document.documentElement.style.setProperty("--c2", settings.website.color3);
    document.documentElement.style.setProperty("--c2c", settings.website.color4);
    document.documentElement.style.setProperty("--c3", settings.website.color1);
    document.documentElement.style.setProperty("--c3c", settings.website.color2);

    if (settings.website) {
      var injectedStyles = document.createElement("style");
      injectedStyles.setAttribute("type", "text/css");
      injectedStyles.innerHTML = settings.website.css;
      document.head.appendChild(injectedStyles);
    }
  };

  const loadLabels = async () => {
    console.log("loadLabels");
    const response = await api.post("/labels/list/", {
      type: "website",
    });
    setLabels(response.rows);
  };

  const loadPages = async () => {
    console.log("loadPages");
    const res = await api.post("/pages/list/", {
      orderby: "title",
    });
    if (res.success == 0) alert(res.error);
    else setPages(res.rows);
  };

  const loadSlides = async () => {
    const response = await api.post("/slides/list/", {
      orderby: "position",
      src: [
        { name: "active", value: 1, compare: "equal" },
        { name: "website", value: 1, compare: "equal" },
      ],
    });
    setLoading(false);
    if (response.success == 0)
      setConfirm({
        title: "Errore",
        message: response.error,
      });
    else setSlides(response.rows);
  };

  const loadNews = async () => {
    const response = await api.post("/news/list/", {
      orderby: "date DESC",
      lang: lang,
    });
    setLoading(false);
    if (response.success == 0)
      setConfirm({
        title: "Errore",
        message: response.error,
      });
    else setNews(response.rows);
  };

  const loadPopups = async () => {
    console.log("loadPopups");
    const res = await api.post("/popups/list/", {
      orderby: "position",
      src: [
        { name: "active", value: 1, compare: "equal" },
        { name: "website", value: 1, compare: "equal" },
      ],
    });
    if (res.success == 0) alert(res.error);
    else setPopups(res.rows);
  };

  const loadShops = async () => {
    console.log("loadShops");
    const res = await api.post("/shops/list/", {
      fields: [
        "id",
        "name",
        "meta_url",
        "img",
        "address",
        "number",
        "zipcode",
        "city",
        "province",
        "phone",
        "email",
        "coord",
        "times_text",
        "delivery",
        "takeaway",
        "active_reservations",
        "description",
        "additional_info",
        "gallery_id",
        "reservations_ext_url",
      ],
      orderby: "position",
      src: [
        {
          name: "active",
          value: 1,
          compare: "equal",
        },
      ],
    });
    if (res.success == 0) alert(res.error);
    else setShops(res.rows);
  };

  async function loadProductsStock() {
    const response = await api.post("/products_stock/list_for_clients/");
    if (response.success == 0) alert(response.error);
    else setStock(response.rows);
  }

  // Sconti-prodotto. Due modalita':
  // - "menu": le regole statiche arrivano con il menu (menu/courses_flat, chiave discounts_products). Solo quantita' residua e
  //   chiusura per cliente (one_per_customer) dipendono da carrello e cliente: si leggono da discounts_products/availability, e solo
  //   se esiste almeno uno sconto a quantita' limitata o one_per_customer.
  // - "legacy": il menu in cache non ha ancora la chiave (non rigenerato dopo il rilascio): si usa discounts_products/list come prima.
  const [discountsMode, setDiscountsMode] = useState(null);
  const [discountRules, setDiscountRules] = useState([]);
  const [discountsAvail, setDiscountsAvail] = useState(null);
  const discountsNeedAvailability = discountRules.some((rule) => rule.has_qty_limit == 1 || rule.one_per_customer == 1);

  // solo l'ultima richiesta conta: dopo un login la risposta del carrello ospite non deve sovrascrivere quella del cliente
  const discountsAvailRequestRef = useRef(0);

  const loadDiscountsAvailability = async () => {
    const requestId = ++discountsAvailRequestRef.current;
    const res = await api.post("/discounts_products/availability/", {
      customer_id: user ? user.id : null,
    });
    if (requestId !== discountsAvailRequestRef.current) return;
    // se la lettura fallisce si procede comunque (quantita' 0 per gli sconti a quantita' limitata) invece di non applicare nessuno sconto
    if (res.success == 0) {
      setDiscountsAvail({});
      return;
    }
    const avail = {};
    for (const row of res.rows) avail[row.id] = { qty: row.qty, hidden: row.hidden };
    setDiscountsAvail(avail);
  };

  useEffect(() => {
    if (discountsMode === "legacy") loadDiscounts();
    if (discountsMode === "menu" && discountsNeedAvailability) {
      // la disponibilita' vale per un cliente: cambiando cliente quella vecchia non e' piu' valida
      setDiscountsAvail(null);
      loadDiscountsAvailability();
    }
  }, [discountsMode, discountRules, user?.id]);

  useEffect(() => {
    if (discountsMode !== "menu") return;
    // gli sconti compaiono tutti insieme: finche' la disponibilita' non e' arrivata non se ne mostra nessuno,
    // altrimenti il menu cambia a meta' caricamento (prima quelli senza limiti, poi quelli a quantita' o per cliente)
    if (discountsNeedAvailability && discountsAvail === null) return;
    const rows = [];
    for (const rule of discountRules) {
      const avail = discountsAvail ? discountsAvail[rule.id] : null;
      if (avail && avail.hidden == 1) continue;
      rows.push({ ...rule, qty: rule.has_qty_limit == 1 ? (avail ? avail.qty : 0) : null });
    }
    setDiscounts(rows);
  }, [discountsMode, discountRules, discountsAvail, user?.id]);

  const loadDiscounts = async () => {
    console.log("loadDiscounts");
    const res = await api.post("/discounts_products/list/", {
      customer_id: user ? user.id : null,
    });
    if (res.success == 0) alert(res.error);
    else setDiscounts(res.rows);
  };

  const loadMenu = async () => {
    console.log("loadMenu");
    const flatResponse = await api.get("/menu/courses_flat/");
    if (flatResponse.success === 0 || !flatResponse.data) {
      alert(flatResponse.error || "Errore nel caricamento del menu");
      return;
    }

    try {
      const adaptedMenu = adaptMenuFlat(flatResponse);
      setMenu(adaptedMenu.menu);
    } catch (error) {
      console.error("menu_flat adapt failed", error);
      alert("Errore nel parsing del menu");
    }

    // sconti-prodotto: dal menu se presenti, altrimenti dalla vecchia lista (menu in cache non ancora rigenerato)
    if (Array.isArray(flatResponse.data.discounts_products)) {
      setDiscountRules(flatResponse.data.discounts_products);
      setDiscountsMode("menu");
    } else {
      setDiscountsMode("legacy");
    }
  };

  function filterMenu() {
    console.log("filterMenu", shop, listId);
    let res = [];
    for (const course of menu) {
      let cr = JSON.parse(JSON.stringify(course));
      cr.categories = [];
      for (const category of course.categories) {
        if (category.active_website == 1 && checkCategoryTimes(category)) {
          let ct = JSON.parse(JSON.stringify(category));
          ct.products = [];
          for (const product of category.products) {
            if (product.active_website == 1) {
              let p = filterVariants(product);
              p.stock = getProductStock(p.id);
              if (!isStockCheckDisabled() && p.stock !== false && parseInt(p.stock) == 0) continue;
              if (shop && listId) {
                const priceList = product.prices.filter((el) => {
                  return el.list_id == listId && el.price;
                });
                const assortment = product.assortment.filter((el) => {
                  return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
                });
                if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(product)) {
                  p.price = priceList[0].price;
                  ct.products.push(p);
                }
              } else if (shop) {
                if (checkIngredientsAssortment(product)) {
                  ct.products.push(p);
                }
              } else {
                ct.products.push(p);
              }
            }
          }
          ct = applyDiscounts(ct);
          if (ct.products.length > 0) cr.categories.push(ct);
        }
      }
      if (cr.categories.length > 0) res.push(cr);
    }
    res = generatePromoCategory(res);
    setCourses(res);
  }

  const filterVariants = (product) => {
    const normalizeOrigins = (originsRaw) => {
      if (Array.isArray(originsRaw))
        return originsRaw
          .map((origin) =>
            String(origin || "")
              .trim()
              .toLowerCase(),
          )
          .filter(Boolean);
      if (typeof originsRaw === "string")
        return originsRaw
          .split(",")
          .map((origin) =>
            String(origin || "")
              .trim()
              .toLowerCase(),
          )
          .filter(Boolean);
      return [];
    };

    const isVariantCategoryEnabledForWebsite = (variantsCategory) => {
      const origins = normalizeOrigins(variantsCategory?.origins);
      if (origins.length === 0) return true;
      if (origins.includes("website")) return true;
      return false;
    };

    const shouldZeroVariantPrice = (variantsCategory) => Number(variantsCategory?.has_price) !== 1;

    let p = JSON.parse(JSON.stringify(product));
    p.variants_categories = [];
    for (const variants_category of product.variants_categories) {
      if (!isVariantCategoryEnabledForWebsite(variants_category)) continue;
      let vc = JSON.parse(JSON.stringify(variants_category));
      vc.variants = [];
      vc.variants2 = [];
      vc.products = [];
      vc.products2 = [];
      for (const variant of variants_category.variants) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && listId) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == listId && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = shouldZeroVariantPrice(variants_category) ? 0 : priceList[0].price;
            vc.variants.push(v);
          }
        } else {
          if (shouldZeroVariantPrice(variants_category)) v.price = 0;
          vc.variants.push(v);
        }
      }
      for (const variant of variants_category.variants2) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && listId) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == listId && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = shouldZeroVariantPrice(variants_category) ? 0 : priceList[0].price;
            vc.variants2.push(v);
          }
        } else {
          if (shouldZeroVariantPrice(variants_category)) v.price = 0;
          vc.variants2.push(v);
        }
      }
      for (const subproduct of variants_category.products) {
        let v = JSON.parse(JSON.stringify(subproduct));
        if (shop && listId) {
          const priceList = subproduct.prices.filter((el) => {
            return el.list_id == listId && el.price !== null;
          });
          const assortment = subproduct.assortment
            ? subproduct.assortment.filter((el) => {
                return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
              })
            : [1];
          if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(subproduct)) {
            v.price = shouldZeroVariantPrice(variants_category) ? 0 : priceList[0].price;
            vc.products.push(v);
          }
        } else if (shop) {
          if (checkIngredientsAssortment(subproduct)) {
            if (shouldZeroVariantPrice(variants_category)) v.price = 0;
            vc.products.push(v);
          }
        } else {
          if (shouldZeroVariantPrice(variants_category)) v.price = 0;
          vc.products.push(v);
        }
      }
      if (variants_category.products2) {
        for (const subproduct of variants_category.products2) {
          let v = JSON.parse(JSON.stringify(subproduct));
          if (shop && listId) {
            const priceList = subproduct.prices.filter((el) => {
              return el.list_id == listId && el.price !== null;
            });
            const assortment = subproduct.assortment
              ? subproduct.assortment.filter((el) => {
                  return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
                })
              : [1];
            if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(subproduct)) {
              v.price = shouldZeroVariantPrice(variants_category) ? 0 : priceList[0].price;
              vc.products2.push(v);
            }
          } else if (shop) {
            if (checkIngredientsAssortment(subproduct)) {
              if (shouldZeroVariantPrice(variants_category)) v.price = 0;
              vc.products2.push(v);
            }
          } else {
            if (shouldZeroVariantPrice(variants_category)) v.price = 0;
            vc.products2.push(v);
          }
        }
      }
      if (vc.force_mono == 1) {
        vc.min = 0;
        vc.max = vc.variants.length + vc.variants2.length + vc.products.length + vc.products2.length;
      }
      if (
        vc.variants.length > 0 ||
        vc.variants2.length > 0 ||
        vc.products.length > 0 ||
        vc.products2.length > 0
      )
        p.variants_categories.push(vc);
    }
    return p;
  };

  const getProductStock = (productId) => {
    if (!stock) return false;
    const s = stock.find((e) => e.shop_id == shop.id && e.product_id == productId);
    if (s) return s.qty;
    return false;
  };

  const isStockCheckDisabled = () => settings?.menu_api?.disable_stock_check_customers == 1;

  const checkIngredientsAssortment = (product) => {
    if (!settings.menu_api) return true;
    if (!settings.menu_api.enable_ingredients_assortment) return true;
    if (settings.menu_api.enable_ingredients_assortment != 1) return true;
    if (!product.ingredients) return true;
    if (product.ingredients.length == 0) return true;
    //console.log("check_ingredients_assortment", product.name);
    for (const ingredient of product.ingredients) {
      const assortment = ingredient.assortment.filter((el) => {
        return el.shop_id == shop.id && el.active == 1;
      });
      if (assortment.length == 0) return false;
    }
    return true;
  };

  const isWebsiteCategoryTimesEnabled = () => {
    return settings?.menu_api?.enable_categories_times_website == 1;
  };

  const getCategoryTimesDate = (deliveryDate = cart?.delivery_date) => {
    if (!deliveryDate) return null;
    const date = moment(deliveryDate, "YYYY-MM-DD HH:mm:ss", true);
    if (date.isValid()) return date;
    const fallbackDate = moment(deliveryDate);
    return fallbackDate.isValid() ? fallbackDate : null;
  };

  const checkCategoryTimes = (category, deliveryDate = cart?.delivery_date) => {
    if (!isWebsiteCategoryTimesEnabled()) return true;

    const date = getCategoryTimesDate(deliveryDate);
    if (!date) return true;
    let day = date.day() - 1;
    if (day < 0) day = 6;
    if (category.times != null) {
      const times = category.times[day];
      if (!times) return false;
      let enabled = false;

      const selectedTime = date.hours() * 100 + date.minutes();
      for (let service = 1; service <= 2; service++) {
        const serviceTimes = times["s" + service];
        if (!serviceTimes) continue;
        let open_h = serviceTimes.open.h;
        let open_m = serviceTimes.open.m;
        let close_h = serviceTimes.close.h;
        let close_m = serviceTimes.close.m;

        if (open_h != "" && close_h != "") {
          if (parseInt(close_h) === 0) {
            close_h = 24;
            close_m = 0;
          }
          if (parseInt(close_h) < parseInt(open_h)) {
            close_h = 24;
            close_m = 0;
          }
          const t_open = open_h * 100 + parseInt(open_m || 0);
          const t_close = close_h * 100 + parseInt(close_m || 0);
          if (selectedTime >= t_open && selectedTime <= t_close) enabled = true;
        }
      }
      if (enabled) return true;
    }
    return false;
  };

  const isProductAvailableForCategoryTimes = (productId, deliveryDate = cart?.delivery_date) => {
    if (!isWebsiteCategoryTimesEnabled()) return true;
    if (!productId) return true;
    if (!menu || menu.length === 0) return true;

    for (const course of menu) {
      for (const category of course.categories || []) {
        if (category.active_website != 1) continue;
        if (!Array.isArray(category.products)) continue;
        if (category.products.some((product) => product.id == productId)) {
          if (checkCategoryTimes(category, deliveryDate)) return true;
        }
      }
    }
    return false;
  };

  const filterCartProductsByCategoryTimes = async () => {
    if (!cart || !Array.isArray(cart.products) || cart.products.length === 0) return;
    if (!isWebsiteCategoryTimesEnabled()) return;
    if (!menu || menu.length === 0) return;

    const invalidProducts = cart.products.filter(
      (product) => !isProductAvailableForCategoryTimes(product.product_id, cart.delivery_date),
    );
    if (invalidProducts.length === 0) return;

    const filterKey = [
      cart.delivery_date || "",
      invalidProducts.map((product) => product.item_id).join(","),
    ].join("|");
    if (categoryTimesCartFilterRef.current === filterKey) return;
    categoryTimesCartFilterRef.current = filterKey;

    setLoading(true);
    const uId = user ? user.id : tempId;
    const endpoint = user ? "/cart/edit_product/" : "/cart/edit_product/";
    let lastResponse = null;
    for (const product of invalidProducts) {
      const request = { item_id: product.item_id, qty: 0 };
      lastResponse = user
        ? await api.postProtected(endpoint + uId + "/", request)
        : await api.post(endpoint + uId + "/", request);
      if (lastResponse.success === 0) {
        alert(lastResponse.error);
        setLoading(false);
        return;
      }
    }
    if (lastResponse?.data) loadCart(lastResponse.data);
    else setLoading(false);
  };

  const applyDiscounts = (category) => {
    //console.log("applyDiscount");
    for (const product of category.products) {
      if (discounts && discounts.length > 0 && cart.shop_id) {
        for (const discount of discounts) {
          if (product.id == discount.product_id) {
            const normalizeIds = (ids) => {
              if (Array.isArray(ids)) return ids.map((id) => String(id));
              if (typeof ids === "string")
                return ids
                  .split(",")
                  .map((id) => String(id).trim())
                  .filter(Boolean);
              return [];
            };

            const discountShopIds = normalizeIds(discount.shops_ids);
            const discountListIds = normalizeIds(discount.lists_ids);
            const cartShopId = String(cart.shop_id);
            const currentListId = listId ? String(listId) : null;

            //alert(JSON.stringify(discount.lists_ids));
            //alert(cart.list_id);
            //alert(discount.lists_ids.includes(cart.list_id.toString()));
            if (
              (discountShopIds.length == 0 || discountShopIds.includes(cartShopId)) &&
              (discountListIds.length == 0 || (currentListId && discountListIds.includes(currentListId))) &&
              (!discount.date_start ||
                moment(String(cart.delivery_date).replace("asap-", ""), "YYYY-MM-DD HH:mm:ss").startOf("day") >=
                  moment(discount.date_start)) &&
              (!discount.date_end ||
                moment(String(cart.delivery_date).replace("asap-", ""), "YYYY-MM-DD HH:mm:ss").startOf("day") <=
                  moment(discount.date_end)) &&
              (discount.qty === null || discount.qty === undefined || discount.qty === "" || discount.qty > 0)
            ) {
              //alert("test");
              product.discounted = true;
              product.discount = {
                category: "discounts_products",
                one_per_customer: discount.one_per_customer,
                date_start: discount.date_start,
                date_end: discount.date_end,
                type: discount.type,
                value: discount.value,
                // il prezzo scontato non puo' andare sotto zero (sconto fisso maggiore del prezzo)
                price: Math.max(
                  0,
                  discount.type == "perc"
                    ? parseFloat(product.price) - (parseFloat(product.price) / 100) * discount.value
                    : product.price - discount.value
                ),
              };
              // vale la prima regola valida (come sul server): le successive non la sovrascrivono
              break;
            }
          }
        }
      } else {
        product.discounted = false;
        product.discount = null;
      }
    }
    return category;
  };

  const generatePromoCategory = (menu) => {
    const discountedProductsById = new Map();
    for (const course of menu) {
      for (const category of course.categories) {
        for (const product of category.products) {
          if (
            product.discounted &&
            product.discount.one_per_customer == 1 &&
            !discountedProductsById.has(product.id)
          ) {
            discountedProductsById.set(product.id, product);
          }
        }
      }
    }
    const discountedProducts = Array.from(discountedProductsById.values());

    if (menu.length > 0)
      menu[0].categories.unshift({
        id: -2,
        name: <Label number={174} />,
        products: discountedProducts,
      });
    return menu;
  };

  const getTranslatedString = (obj, name) => {
    if (settings.mandant.multilanguage == 0) return obj[name];
    if (obj["translations"] && !obj["translations"][lang]) return obj[name];
    if (obj["translations"] && obj["translations"][lang][name]) return obj["translations"][lang][name];
    return obj[name];
  };

  const loadCart = async () => {
    console.log("loadCart", api.getHostname());
    let request = {
      lang: lang,
      hotel_id: hotel,
      locked_shop_id: shopLocked,
    };
    if (user) {
      const response = await api.postProtected("/cart/get/" + user.id + "/", request);
      setLoading(false);
      if (response.success === 0) alert(response.error);
      else {
        setCart(response.data);
        setListId(response.data.list_id);
        setShop(response.data.shop_id ? response.data.shop : false);
        return response.data;
      }
    } else {
      let tId;
      if (tempId) tId = tempId;
      else {
        tId = uuid();
        localStorage.setItem("website-temp-id", tId);
        setTempId(tId);
      }
      const response = await api.post("/temp_cart/get/" + tId + "/", request);
      setLoading(false);
      if (response.success === 0) alert(response.error);
      else {
        setCart(response.data);
        setListId(response.data.list_id);
        setShop(response.data.shop_id ? response.data.shop : false);
        return response.data;
      }
    }
  };

  const editCart = async (request) => {
    console.log("editCart");

    markUserChange();

    setLoading(true);
    if (user) {
      const response = await api.post("/cart/edit/" + user.id + "/", request);
      if (response.success === 0) {
        alert(response.error);
        setLoading(false);
      } else {
        if (request.hotel_id === null) setHotel(false);
        else loadCart(response.data);
      }
    } else {
      const response = await api.post("/cart/edit/" + tempId + "/", request);
      if (response.success === 0) {
        alert(response.error);
        setLoading(false);
      } else {
        if (request.hotel_id === null) setHotel(false);
        else loadCart(response.data);
      }
    }
  };

  const emptyCart = async (request) => {
    console.log("emptyCart");
    setConfirm({
      title: <Label number={38} />,
      onConfirm: async () => {
        setLoading(true);
        if (user) {
          const response = await api.post("/cart/empty/" + user.id + "/", request);
          if (response.success === 0) {
            alert(response.error);
            setLoading(false);
          } else loadCart(response.data);
        } else {
          const response = await api.post("/cart/empty/" + tempId + "/", request);
          if (response.success === 0) {
            alert(response.error);
            setLoading(false);
          } else loadCart(response.data);
        }
      },
    });
  };

  const handleAddProduct = (
    product,
    apply_discount = 0,
    selectedVariants = [],
    selectedSubroducts = [],
    notes = "",
  ) => {
    console.log("handleAddProduct", apply_discount, selectedVariants, selectedSubroducts, product.stock);
    if (!cartEnabled) setCartEnabled(true);
    else if (product.discounted && product.discount.one_per_customer == 1 && !user) {
      setLoginPopup(true);
    } else if (
      !isStockCheckDisabled() &&
      product.stock !== false &&
      (product.stock == 0 || !checkCartQty(product))
    ) {
      setConfirm({
        title: "Prodotto esaurito",
      });
    } else {
      addProduct(product, selectedVariants, selectedSubroducts, notes, apply_discount);
      setSelectedProduct(false);
    }
  };

  function checkCartQty(product) {
    console.log("checkCartQty");
    if (isStockCheckDisabled()) return true;
    let cartQty = 0;
    for (const p of cart.products) {
      if (p.product_id == product.id) cartQty += parseInt(p.qty);
    }
    console.log(cartQty);
    if (cartQty < product.stock) return true;
    return false;
  }

  const addProduct = async (product, variants = [], subproducts = [], notes = "", apply_discount = 0) => {
    console.log("addProduct");
    const selectedVariantQty = new Map(
      variants.map((variant) => [`${variant.variant_category_id}:${variant.id}`, variant.qty]),
    );
    const selectedSubproductQty = new Map(
      subproducts.map((subproduct) => [`${subproduct.variant_category_id}:${subproduct.id}`, subproduct.qty]),
    );
    const cartVariants = [];
    const cartSubproducts = [];

    for (const variantsCategory of product.variants_categories || []) {
      const shouldPersistZeroQty = Number(variantsCategory?.is_ingredients) === 1;
      for (const variant of [...(variantsCategory.variants || []), ...(variantsCategory.variants2 || [])]) {
        const key = `${variantsCategory.id}:${variant.id}`;
        const qty = selectedVariantQty.get(key) ?? 0;
        if (qty > 0 || shouldPersistZeroQty) {
          cartVariants.push({
            id: variant.id,
            qty: qty,
            variant_category_id: variantsCategory.id,
            price: variant.price,
          });
        }
      }
      for (const subproduct of [
        ...(variantsCategory.products || []),
        ...(variantsCategory.products2 || []),
      ]) {
        const key = `${variantsCategory.id}:${subproduct.id}`;
        const qty = selectedSubproductQty.get(key) ?? 0;
        if (qty > 0 || shouldPersistZeroQty) {
          cartSubproducts.push({
            id: subproduct.id,
            qty: qty,
            variant_category_id: variantsCategory.id,
            price: subproduct.price,
          });
        }
      }
    }

    let uId;
    if (user) uId = user.id;
    else uId = tempId;
    setLoading(true);
    const response = await api.post("/cart/add_product/" + uId + "/", {
      product_id: product.id,
      qty: 1,
      variants: cartVariants,
      products: cartSubproducts,
      notes: notes,
      apply_discount: apply_discount,
    });
    if (response.success === 0) {
      alert(response.error);
      setLoading(false);
    } else {
      loadCart(response.data);
      if (settings.menu_api?.enable_related_products_on_cart_add == 1) {
        if (loadRelated) getRelatedProducts(getCartProductsIds(), product.id);
        else setRelatedProducts(false);
      }
    }
  };

  const getCartProductsIds = () => {
    let res = [];
    for (const product of cart.products) {
      res.push(product.product_id);
    }
    return res;
  };

  const handleEditProduct = (product, qty) => {
    const p = cart.products.find((p) => p.item_id == product.item_id);
    const s = stock.find((s) => s.product_id == p.product_id && s.shop_id == shop.id);
    if (qty < p.qty) {
      editProduct({
        item_id: product.item_id,
        qty: qty,
      });
    } else if (!cartEnabled) setCartEnabled(true);
    else if (isStockCheckDisabled() || s === undefined || parseInt(s.qty) > parseInt(p.qty)) {
      editProduct({
        item_id: product.item_id,
        qty: qty,
      });
    }
  };

  const editProduct = async (request) => {
    console.log("editProduct");
    setLoading(true);
    if (user) {
      const response = await api.postProtected("/cart/edit_product/" + user.id + "/", request);
      if (response.success === 0) {
        alert(response.error);
        setLoading(false);
      } else loadCart(response.data);
    } else {
      const response = await api.post("/cart/edit_product/" + tempId + "/", request);
      if (response.success === 0) {
        alert(response.error);
        setLoading(false);
      } else loadCart(response.data);
    }
  };

  const getHomeComponent = () => {
    if (hotel || cart.hotel_id) {
      return <Store />;
    } else if (settings.website.hide_home == 1) {
      if (hasOrders) return <Store />;
      else return <Booking />;
    } else return <Home />;
  };

  const getRelatedProducts = async (ids, id = null) => {
    console.log("getRelatedProducts", ids);
    const response = await api.post("/related_products/get/", { ids: ids, id: id });
    if (response.success === 0) {
      alert(response.error);
    } else {
      //console.log(response);
      let res = [];
      for (const rpId of response.rows) {
        //console.log(rpId);
        for (const course of courses) {
          for (const category of course.categories) {
            if (category.id != -2) {
              for (const product of category.products) {
                let p = JSON.parse(JSON.stringify(product));
                if (product.id == rpId) res.push(p);
              }
            }
          }
        }
      }
      //console.log(res);
      if (res.length > 0) setRelatedProducts(res);
      else setRelatedProducts(false);
    }
  };

  const loadDiscountsLimit = async () => {
    console.log("loadDiscountsLimit");
    const res = await api.post("/discounts_limit/list/", {
      orderby: "order_min",
      src: [
        {
          name: cart.delivery_type == "delivery" ? "delivery" : "takeaway",
          compare: "equal",
          value: 1,
        },
      ],
    });
    if (res.success == 0) alert(res.error);
    else setDiscountsLimit(res.rows);
  };

  function ErrorBoundary() {
    let error = useRouteError();
    console.log("Error found");
    console.error(error);
    // Uncaught ReferenceError: path is not defined
    return (
      <div style={{ textAlign: "center" }}>
        <h2>Si è verificato un errore</h2>
        <p>{error.message}</p>
        <p>{error.name}</p>
        <p>{error.stack}</p>
      </div>
    );
  }

  const router =
    settings &&
    createBrowserRouter(
      createRoutesFromElements(
        <Route path="/" element={<Layout />} errorElement={<ErrorBoundary />}>
          <Route path="/it" element={getHomeComponent()} />
          <Route path="/it/" element={getHomeComponent()} />
          <Route index element={getHomeComponent()} />
          <Route path="home" element={getHomeComponent()} />
          <Route path="login" element={<Login />} />
          <Route path="check_email" element={<LoginCheckEmail />} />
          <Route path="email_login" element={<LoginEmailLogin />} />
          <Route path="check_mobile" element={<LoginCheckMobile />} />
          <Route path="signup_mobile" element={<SignUpMobile />} />
          <Route path="check_code_mobile" element={<CheckCodeMobile />} />
          <Route path="mobile_login" element={<LoginMobileLogin />} />
          <Route path="check_hotel" element={<LoginCheckHotel />} />
          <Route path="check_code_hotel" element={<CheckCodeHotel />} />
          <Route path="check_password_code_sms" element={<CheckPasswordCodeSms />} />
          <Route path="password/new/:id/" element={<RestorePassword />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="check_code" element={<CheckCode />} />
          <Route path="check_password_code" element={<CheckPasswordCode />} />
          <Route path="new_password" element={<NewPassword />} />
          <Route path="brands" element={<Brands />} />
          <Route path="store" element={<Store />} />
          <Route path="store/:categoryId" element={<Store />} />
          <Route path="/login/sms" element={<Store />} />
          <Route
            path="checkout"
            element={
              settings.website.guest_mode == 1 || user || (cart && cart.hotel_id) ? <Checkout /> : <Login />
            }
          />
          <Route path="order_confirmed" element={<OrderConfirmed />} />
          <Route path="booking" element={<Booking />} />
          <Route path="booking_confirmed" element={<BookingConfirmed />} />
          <Route path="cms/:id/:slug?" element={<Cms />} />
          <Route path="shops" element={<Shops />} />
          <Route path="shops/:id/:slug?" element={<Shop />} />
          <Route path="userboard" element={<Userboard />} />
          <Route path="billing_address" element={<BillingAddress />} />
          <Route path="billing_address/:id" element={<BillingAddress />} />
          <Route path="orders" element={<Orders />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="bookings/:id" element={<BookingSheet />} />
          <Route path="points_transactions" element={<PointsTransactions />} />
          <Route path="credits_transactions" element={<CreditTransactions />} />
          <Route path="promo" element={<Promo />} />
          <Route path="news" element={<NewsList />} />
          <Route path="news/:id" element={<News />} />
          <Route path="*" element={<NotFound />} />
        </Route>,
      ),
    );

  if (lock || !settings) return <div className="lock">{settings && <img src={settings.website.logo} />}</div>;

  const hotelInactive = cart?.hotel && Number(cart.hotel.active) === 0;
  const isHotelServiceInactive = hotelServiceInactive || hotelInactive;

  return (
    <GoogleOAuthProvider clientId={settings.google.client_id}>
      <AppContext.Provider
        value={{
          settings,
          shops,
          setLoading,
          brand,
          setBrand,
          pages,
          labels,
          lang,
          setLang,
          getTranslatedString,
          courses,
          shop,
          category,
          setCategory,
          cart,
          editCart,
          emptyCart,
          addProduct,
          editProduct,
          confirm,
          setConfirm,
          user,
          setUser,
          loadCart,
          lastOrderId,
          setLastOrderId,
          lastOrderNumber,
          setLastOrderNumber,
          tempId,
          pagePopup,
          setPagePopup,
          reloadUser,
          tempUser,
          setTempUser,
          loginPopup,
          setLoginPopup,
          track,
          discounts,
          news,
          menus,
          slides,
          popups,
          mainSettings,
          hotel,
          hotelInfo,
          hotelAvailableChilds,
          hotelAvailableBrands,
          hasOrders,
          hasReservations,
          loginRedirect,
          setLoginRedirect,
          c1,
          setC1,
          cookieSettingsPopupVisible,
          setCookieSettingsPopupVisible,
          setHotel,
          lastOrderTotal,
          setLastOrderTotal,
          hasDelivery,
          hasTakeaway,
          handleAddProduct,
          cartEnabled,
          setCartEnabled,
          selectedProduct,
          setSelectedProduct,
          relatedProducts,
          setRelatedProducts,
          setLoadRelated,
          storePopupVisible,
          setStorePopupVisible,
          loadRelated,
          getRelatedProducts,
          discountsLimit,
          stock,
          handleEditProduct,
          markUserChange,
          brandSelectionAtOrderInit,
          hotelBrandSelectionRequired,
          brandPopupVisible,
          setBrandPopupVisible,
          brandPopupRedirect,
          openBrandSelectionPopup,
          lock,
          brandSettingsLoadedVersion,
          forceMainBrandNavigation,
          masterFooterMenus,
          masterFooterPages,
          masterFooterShops,
          masterFooterLoaded,
          navigateViaMaster,
          hasSavedBrandAtInit: HAS_SAVED_BRAND_AT_INIT,
        }}
      >
        {settings.website.maintenance == 1 ? (
          <Maintenance />
        ) : isHotelServiceInactive ? (
          <Maintenance
            title="Servizio non attivo"
            message="Contatta la struttura oppure seleziona un servizio diverso."
            action={
              <button
                className="button button-primary"
                onClick={async () => {
                  localStorage.removeItem("website-hotel-id");
                  await editCart({ hotel_id: null });
                }}
              >
                <Label number={200} />
              </button>
            }
          />
        ) : (
          <>
            {mainSettings.mandant.childs.length > 0 &&
            !brand &&
            !brandSelectionAtOrderInit &&
            !hotelBrandSelectionRequired ? (
              <Brands />
            ) : (
              <>
                {<RouterProvider router={router} />}
                {(brandSelectionAtOrderInit ||
                  hotelBrandSelectionRequired ||
                  (hotel && hotelAvailableBrands.length > 1)) &&
                  brandPopupVisible && <Brands />}
                {pagePopup && <PagePopup />}
                {relatedProducts && <RelatedProductsPopup />}
                {selectedProduct && (
                  <ProductSheet product={selectedProduct} setSelectedProduct={setSelectedProduct} />
                )}
                {storePopupVisible && <StorePopUp />}
                {promoPopupVisible && <PromoPopup onClose={() => setPromoPopupVisible(false)} />}
                <CmsPopups />
                <CmsPopups mode="cart" shopId={cart.shop_id ? cart.shop_id : false} />
                <Confirm />
              </>
            )}
          </>
        )}

        {loading && (
          <div id="loading">
            <div className="content">
              <LoadIcon className="fa-spin"></LoadIcon>
            </div>
          </div>
        )}
      </AppContext.Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
